"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBEMClasses = exports.addModifier = void 0;
var _reactBemHelper = _interopRequireDefault(require("react-bem-helper"));
var _pickBy = _interopRequireDefault(require("lodash/pickBy"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var getBEMClasses = exports.getBEMClasses = function getBEMClasses() {
  var _Array$prototype;
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }
  classes = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, _toConsumableArray(classes)).filter(function (item) {
    return item;
  });
  var BEMClasses = classes.map(function (className) {
    return new _reactBemHelper["default"]({
      name: className,
      outputIsString: true
    });
  });
  return function (element, modifier) {
    return BEMClasses.map(function (BEMClass) {
      return BEMClass(element, processModifiers(modifier));
    }).join(' ');
  };
};
function processModifiers(modifiers) {
  return isObject(modifiers) ? (0, _pickBy["default"])(modifiers) : modifiers;
}
function isObject(obj) {
  return obj === Object(obj) && !Array.isArray(obj);
}
var addModifier = exports.addModifier = function addModifier(modifiers, newModifier) {
  var result;
  if (Array.isArray(modifiers)) {
    result = [newModifier].concat(_toConsumableArray(modifiers));
  } else if (typeof modifiers === 'string') {
    result = [newModifier, modifiers];
  } else if (_typeof(modifiers) === 'object') {
    result = modifiers;
    result[newModifier] = true;
  }
  return result;
};